// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e905d51c","981":"3c90cad2"}[chunkId] + ".chunk.js";
};